/**
 * Component to render SCA Managed board page
 */
const ManagedBoardPage = (): React.ReactElement => {
  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="managed-board-page-component"
    >
      <p>
        <strong>Objectives of the Award</strong>
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          Focus boards&apos; attention on transparency, accountability,
          performance orientation, good processes and practices;
        </li>
        <li>Provide a multi-dimensional view of board effectiveness;</li>
        <li>
          Underscore the importance of human capital practices at the board
          level;
        </li>
        <li>
          Ratchet up benchmarks by bringing the best out of board practices in
          Singapore.
        </li>
      </ul>

      <p>
        <strong>Categories of the Award</strong>
      </p>

      <p>
        The Award will be presented to the Best Boards in the following
        categories:
      </p>

      <p>
        <strong>Financial Performance/Productivity</strong>
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Companies with market capitalisation of S$1 billion and above;</li>
        <li>
          Companies with market capitalisation of S$300 million to less than S$1
          billion;
        </li>
        <li>
          Companies with market capitalisation of less than S$300 million.
        </li>
      </ul>

      <p>
        <strong>Selection and Judging Process</strong>
      </p>

      <p>
        In Stage 1, all listed companies are screened based on publicly
        available information of total shareholder returns, corporate governance
        practices, and corporate governance indices such as the Singapore
        Governance and Transparency Index and MSCI ESG Rating.
      </p>

      <p>
        A shortlist between 20 to 30 companies in each category will be
        developed.
      </p>

      <p>
        In Stage 2, additional inputs on shortlisted Companies are obtained
        through research and discreet inquiries. The Best Managed Board
        committee will visit companies which are further shortlisted to confirm
        the information and obtain more information on their board practices and
        processes.
      </p>

      <p>
        In Stage 3, a panel of judges will interview the boards of the final
        shortlisted candidates and rank them for the awards.
      </p>

      <p>
        <strong>Criteria</strong>
      </p>

      <p>
        Companies are selected based on the assessment of the following
        criteria:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          <strong>Overall quality of corporate governance:</strong> board and
          committee structure, practices, external validation;
        </li>
        <li>
          <strong>Corporate transparency and governance disclosure:</strong>
          disclosure content and context, governance compliance and reasons for
          non-compliance;
        </li>
        <li>
          <strong>Shareholders&apos; Interest:</strong> shareholder value
          creation and return to shareholders, shareholder communications and
          meetings;
        </li>
        <li>
          <strong>Board composition and accountability:</strong> independence,
          skill-mix, board and gender diversity, working relationships,
          commitment, etc.;
        </li>
        <li>
          <strong>Board functions:</strong> principles and processes, meeting
          and information management, committee functioning, board evaluation;
        </li>
        <li>
          <strong>Directors&apos; development and recognition:</strong> board
          orientation and onboarding, on-going development, alignment of
          director compensation with shareholders&apos; interests;
        </li>
        <li>
          <strong>Risk management:</strong> risk management framework and
          processes;
        </li>
        <li>
          <strong>Leadership and strategic planning:</strong> access to
          management, balance of power, strategic guidance, and decision making;
        </li>
        <li>
          <strong>Succession planning:</strong> nomination and renewal for board
          and key management;
        </li>
        <li>
          <strong>Sustainability and transformation:</strong> sustainable
          initiatives and reporting, operational and IT pivots;
        </li>
        <li>
          <strong>Performance orientation and financials:</strong> board
          directors and executive performance management, company performance
          monitoring, performance-linked executive compensation, overall
          financial performance;
        </li>
        <li>
          <strong>Managing company growth:</strong> optimising resources,
          processes, and personnel to sustainably scale operations and achieve
          long-term success;
        </li>
      </ul>
    </div>
  );
};

export default ManagedBoardPage;
